module.exports = __webpack_public_path__ + "img/sales-orders.217c6420.svg";